var template = require('../templates/Notification.html');

module.exports = Backbone.View.extend({
    el: '.content',

    initialize: function(options) {
        var self = this;
        self.text      = options.text;
        self.loginLink = options.loginLink || false;
        self.render();
    },

    render: function() {
        var self = this;
        self.$el.html(template({
            text:      self.text,
            loginLink: self.loginLink
        }));
        $('body').addClass('gray-bg');
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/Notification.js